import { Type } from "@feathersjs/typebox";
export const FavIdSchema = Type.String({ description: "ERAM FAV id" });
//# sourceMappingURL=fav.js.map